export function resetSize(vm) {
  let imgWidth, imgHeight, barWidth, barHeight; // 图片的宽度、高度，移动条的宽度、高度

  const parentWidth = vm.$el.parentNode.offsetWidth || window.offsetWidth;
  const parentHeight = vm.$el.parentNode.offsetHeight || window.offsetHeight;

  if (vm.imgSize.width.includes("%")) {
    imgWidth = (parseInt(this.imgSize.width) / 100) * parentWidth + "px";
  } else {
    imgWidth = this.imgSize.width;
  }

  if (vm.imgSize.height.includes("%")) {
    imgHeight = (parseInt(this.imgSize.height) / 100) * parentHeight + "px";
  } else {
    imgHeight = this.imgSize.height;
  }

  if (vm.barSize.width.includes("%")) {
    barWidth = (parseInt(this.barSize.width) / 100) * parentWidth + "px";
  } else {
    barWidth = this.barSize.width;
  }

  if (vm.barSize.height.includes("%")) {
    barHeight = (parseInt(this.barSize.height) / 100) * parentHeight + "px";
  } else {
    barHeight = this.barSize.height;
  }

  return {
    imgWidth,
    imgHeight,
    barWidth,
    barHeight,
  };
}
